const styles = () => ({
  container: {
    padding: '20px'
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end'
  }
})

export default styles
